import { createFileRoute } from "@tanstack/react-router"
import { lazy } from "react"
import LazyRoutePage from "../../../-LazyRoutePage"

const PAGE_SIZE_OPTIONS = [25, 50, 100, 200] as const

export const Route = createFileRoute("/_layout/WMS/products/products-list")({
  validateSearch: (search: Record<string, unknown>) => {
    const rawPage =
      typeof search.page === "number"
        ? search.page
        : typeof search.page === "string"
          ? Number.parseInt(search.page, 10) || 1
          : 1
    const rawPageSize =
      typeof search.page_size === "number"
        ? search.page_size
        : typeof search.page_size === "string"
          ? Number.parseInt(search.page_size, 10) || 50
          : 50

    return {
      q: typeof search.q === "string" ? search.q : "",
      page: rawPage,
      page_size: PAGE_SIZE_OPTIONS.includes(
        rawPageSize as (typeof PAGE_SIZE_OPTIONS)[number],
      )
        ? rawPageSize
        : 50,
    }
  },
  component: ProductsListRoute,
})

const ProductsListPage = lazy(
  () => import("../../../../components/WMS/Products/ProductsListPage"),
)

function ProductsListRoute() {
  return (
    <LazyRoutePage>
      <ProductsListPage />
    </LazyRoutePage>
  )
}
